import { Injectable } from "@angular/core";
import { PreviewFrameComponent } from "./preview-frame.component";
import { ScaffoldDialogService, ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";

@Injectable({
  providedIn: "root",
})
export class PreviewFrameService {
  dialogRef: ScaffoldDialogRef;
  constructor(private dialog: ScaffoldDialogService) {}

  openPreview(url, item, prefix?, title?,dontCloseOnClick?): void {
    console.log(url);
    let config: any = {
      closeOnBackdropClick:!dontCloseOnClick,
      context: {
        width: "wide",
        data: {
          dontCloseOnClick,
          prefix,
          item,
          url,
          title,
        },
      },
    };
    this.dialogRef = this.dialog.open(PreviewFrameComponent, config);

    this.dialogRef.onClose.subscribe((result) => {});
  }
}
